const metadataRegex = /<!--[\s\S]*?-->/g;

const removeMetadata = (response) => ({
  ...response,
  message_content: response.message_content.replace(metadataRegex, ''),
});

export default removeMetadata;
